import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Keys, locale } from 'src/i18n';
import { getPDDCounts } from './queries';
import { MyPDDLoan } from './types';
import styles from './index.module.scss';

const renderValue = (value: string | number) => value || '-';

function LoanHeader({ loan }: { loan: MyPDDLoan }) {
  const counts = getPDDCounts(loan);

  return (
    <div className={styles.myPDD__cardHeader}>
      <div className={styles.myPDD__loanInfo}>
        <Text semiBold classNames={styles.myPDD__loanNo}>
          {loan.loanNo}
        </Text>
        <Text type="subText" classNames={styles.myPDD__customer}>
          {renderValue(loan.customerName)}
        </Text>
      </div>

      <div className={styles.myPDD__field}>
        <Text type="subText" classNames={styles.myPDD__fieldLabel}>
          {locale(Keys.ABC_PDD_APPLICATION_NUMBER)}
        </Text>
        <Text semiBold classNames={styles.myPDD__fieldValue}>
          {renderValue(loan.applicationNumber)}
        </Text>
      </div>

      <div className={styles.myPDD__field}>
        <Text type="subText" classNames={styles.myPDD__fieldLabel}>
          {locale(Keys.ABC_PDD_CHANNEL_CODE)}
        </Text>
        <Text semiBold classNames={styles.myPDD__fieldValue}>
          {renderValue(loan.channelCode)}
        </Text>
      </div>

      <div className={styles.myPDD__counts}>
        {counts.map(({ label, value, critical }) => (
          <div
            key={label}
            className={`${styles.myPDD__pill} ${
              critical ? styles.myPDD__pillCritical : ''
            }`}
          >
            <span className={styles.myPDD__pillLabel}>{label}</span>
            <Text semiBold classNames={styles.myPDD__pillValue}>
              {value}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LoanHeader;
